// Mock data for Catching Energy Sdn. Bhd.

export const companyInfo = {
  name: "Catching Energy Sdn. Bhd.",
  tagline: "Advanced Rapid Thermal Treatment Technology",
  description: "A novel method for synthesizing advanced materials with improved performance.",
  mission: "To revolutionize energy sustainability by converting biomass and waste materials into advanced carbon products for next-generation battery technology.",
  email: "catchingenergysdnbhd@gmail.com",
  phone: "+60122091008",
  address: "Kuala Lumpur, Malaysia"
};

export const services = {
  title: "Rapid Thermal Treatment",
  description: "We synthesize your samples following your exact specifications. Choose your desired temperature and treatment duration—we deliver research-ready materials with precision and speed.",
  features: [
    {
      title: "Rapid Turnaround",
      description: "Fast processing times without compromising quality",
      icon: "Zap"
    },
    {
      title: "Custom Synthesis",
      description: "Synthesis to your exact specifications",
      icon: "Settings"
    },
    {
      title: "Precision Control",
      description: "Precise temperature and duration control",
      icon: "Target"
    }
  ],
  specifications: {
    temperature: {
      label: "Temperature (°C)",
      range: "600–3,000°C",
      description: "Wide temperature range for diverse material processing"
    },
    duration: {
      label: "Duration (seconds)",
      range: "1–60 seconds",
      description: "Flexible processing time for optimal results"
    }
  }
};

export const materials = [
  {
    name: "Rice Husk",
    description: "Agricultural waste converted into high-grade carbon",
    category: "Biomass"
  },
  {
    name: "Coconut Shell",
    description: "Sustainable biomass source for carbon production",
    category: "Biomass"
  },
  {
    name: "Empty Fruit Bunch",
    description: "Palm oil waste transformed into valuable carbon",
    category: "Biomass"
  },
  {
    name: "Palm Kernel Shell",
    description: "High-quality carbon from agricultural residue",
    category: "Biomass"
  },
  {
    name: "Waste Tires",
    description: "Recycled tires converted into energy-grade carbon",
    category: "Waste"
  },
  {
    name: "Plastics",
    description: "Plastic waste transformed into sustainable materials",
    category: "Waste"
  }
];

export const industries = [
  {
    name: "Biomass Industry",
    description: "Converting agricultural waste into valuable carbon products for sustainable energy solutions",
    icon: "Leaf",
    applications: ["Rice mills", "Palm oil plantations", "Agricultural processing"]
  },
  {
    name: "Tire Recycling",
    description: "Transforming end-of-life tires into high-performance carbon materials",
    icon: "Recycle",
    applications: ["Tire manufacturers", "Recycling facilities", "Waste management"]
  },
  {
    name: "Battery Industry",
    description: "Supplying advanced carbon and graphene materials for next-generation battery technology",
    icon: "Battery",
    applications: ["EV batteries", "Energy storage", "Consumer electronics"]
  }
];

export const stats = [
  {
    value: "3000°C",
    label: "Max Temperature",
    icon: "Flame"
  },
  {
    value: "1-60s",
    label: "Processing Time",
    icon: "Clock"
  },
  {
    value: "6+",
    label: "Material Types",
    icon: "Layers"
  },
  {
    value: "100%",
    label: "Custom Synthesis",
    icon: "CheckCircle"
  }
];
